import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, _, u ) => {
	return {
		growthPageRoot: {
			minHeight  : "100vh",
			paddingTop : "10rem"
		},
		communityPageContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center",
			gap            : "2rem"
		},
		communityPageInput: {
			padding      : "1rem",
			width        : "20vw",
			background   : theme.other.colors.background.secondary,
			border       : `1px solid ${ theme.other.colors.text.primary }`,
			borderRadius : "4px",
			color        : theme.other.colors.text.primary,

			[u.smallerThan ( "sm" )]: {
				width: "50%"
			}
		},
		communityPageBtn: {
			padding        : "1rem 2rem",
			display        : "flex",
			alignItems     : "center",
			gap            : "1rem",
			justifyContent : "center",
			fontSize       : "1.5rem",
			border         : "none",
			borderRadius   : "10px",
			background     : "linear-gradient(to right,#126bd5,#439aff)",
			color          : "white"
		},
		growthPageHeader: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "space-evenly",
			margin         : "4rem auto",
			gap            : "2rem",
			flexWrap       : "wrap",

			[u.smallerThan ( "md" )]: {
				gap           : "1.6rem",
				// margin        : "4rem 1rem auto",
				flexDirection : "column"
			},

			[u.smallerThan ( "sm" )]: {
				// margin     : "4rem 3rem 2rem",
				alignItems: "stretch"
			}

		},
		secondaryDataContainer: {
			display        : "flex",
			alignItems     : "end",
			justifyContent : "center"
		},
		secondaryImg: {
			margin       : "0 1rem",
			width        : "20px",
			borderRadius : "50%"
		},
		adminPanelWrapper: {
			display    : "flex",
			alignItems : "center"
		},
		dateSelector: {
			display                  : "flex",
			[u.smallerThan ( "md" )] : {
				gap: "0.2rem"
			},
			justifyContent : "center",
			gap            : "2rem",
			alignItems     : "center"
		},
		dateSelectorText: {
			[u.smallerThan ( "md" )]: {
				padding: "0.3rem 0"
			},
			padding   : "1rem 0",
			textAlign : "center"
		},
		showGraphBtn: {
			padding      : "0.8rem 4rem",
			border       : "none",
			borderRadius : "5px",
			color        : "white",
			background   : "linear-gradient(to right, #126bd5,#439aff)",
			cursor       : "pointer"
		},
		showGraphBtnText: {
			fontWeight: "500"
		}
	};
} );
